/* GARDEN EQUIPMENT — Espace pro (verrou léger + commande pro automatique)
   Reproduit proStore.ts + proOrder.ts du repo React. */
(function () {
  "use strict";

  var KEY = "ge-pro";
  var cfg = window.GE_PRO || { code: "GARDEN-PRO", endpoint: "" };

  function isPro() {
    try { return localStorage.getItem(KEY) === "1"; } catch (e) { return false; }
  }
  function apply() {
    document.documentElement.classList.toggle("ge-is-pro", isPro());
  }
  function unlock(code) {
    var ok = (code || "").trim().toLowerCase() === String(cfg.code || "").trim().toLowerCase();
    if (ok) { try { localStorage.setItem(KEY, "1"); } catch (e) {} apply(); }
    return ok;
  }
  function lock() {
    try { localStorage.removeItem(KEY); } catch (e) {}
    apply();
  }

  apply();

  /* ---- Formulaire de déverrouillage (page espace pro) ---- */
  document.addEventListener("submit", function (e) {
    var form = e.target.closest("[data-ge-pro-form]");
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector("[data-ge-pro-input]");
    var err = form.querySelector("[data-ge-pro-error]");
    if (unlock(input ? input.value : "")) {
      if (err) err.hidden = true;
      // Recharge pour afficher tout le contenu pro (tarifs, etc.)
      window.location.reload();
    } else {
      if (err) err.hidden = false;
    }
  });

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-ge-pro-lock]")) {
      e.preventDefault();
      lock();
      window.location.reload();
    }
  });

  /* ---- Commande pro automatique (draft order) ---- */
  function money(cents) {
    try { return (cents / 100).toLocaleString("fr-FR", { style: "currency", currency: "EUR" }); }
    catch (e) { return (cents / 100).toFixed(2) + " €"; }
  }

  function lineUnitHT(item) {
    // Prix HT dégressif posé en propriété de ligne à l'ajout (mode pro), sinon prix courant.
    var p = item.properties && item.properties._pro_unit_ht;
    var v = p ? parseFloat(p) : NaN;
    if (isFinite(v) && v > 0) return v;
    return item.final_price / 100;
  }

  function lineTitle(item) {
    var t = item.product_title;
    if (item.variant_title && item.variant_title !== "Default Title") t += " – " + item.variant_title;
    return t;
  }

  function mailtoFallback(lines, totalHT) {
    var body = ["Bonjour, je souhaite passer la commande professionnelle suivante :", ""];
    lines.forEach(function (l) {
      body.push("- " + l.title + " × " + l.quantity + " — " + l.unitPriceHT.toFixed(2) + " € HT/u. = " + (l.unitPriceHT * l.quantity).toFixed(2) + " € HT");
    });
    body.push("", "Sous-total pro HT : " + totalHT.toFixed(2) + " € HT");
    window.location.href = "mailto:contact@garden-equipment.fr?subject=" +
      encodeURIComponent("Commande professionnelle — Garden Equipment") +
      "&body=" + encodeURIComponent(body.join("\n"));
  }

  function submitProOrder(btn) {
    btn.disabled = true;
    var original = btn.innerHTML;
    btn.textContent = "Création de la commande…";
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items.length) { btn.disabled = false; btn.innerHTML = original; return; }
        var lines = cart.items.map(function (it) {
          return { title: lineTitle(it), quantity: it.quantity, unitPriceHT: lineUnitHT(it), currencyCode: "EUR" };
        });
        var totalHT = lines.reduce(function (s, l) { return s + l.unitPriceHT * l.quantity; }, 0);

        if (!cfg.endpoint) { mailtoFallback(lines, totalHT); btn.disabled = false; btn.innerHTML = original; return; }

        fetch(cfg.endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ lines: lines }),
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res && res.ok && res.invoiceUrl) { window.location.href = res.invoiceUrl; }
            else { mailtoFallback(lines, totalHT); btn.disabled = false; btn.innerHTML = original; }
          })
          .catch(function () { mailtoFallback(lines, totalHT); btn.disabled = false; btn.innerHTML = original; });
      })
      .catch(function () { btn.disabled = false; btn.innerHTML = original; });
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-ge-cart-pro-order]");
    if (btn) { e.preventDefault(); submitProOrder(btn); }
  });

  window.GEPro = { isPro: isPro, unlock: unlock, lock: lock };
})();
